import type { ReactElement } from 'react';

export interface RangePickerProps {
  startDate: string;
  endDate: string;
  onStartChange: (iso: string) => void;
  onEndChange: (iso: string) => void;
  onGenerate: () => void;
  generating: boolean;
}

export function RangePicker({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  onGenerate,
  generating,
}: RangePickerProps): ReactElement {
  return (
    <div
      className="flex flex-wrap items-end gap-2"
      data-testid="shopping-range"
    >
      <label className="flex flex-col text-xs" style={{ color: 'var(--text-muted)' }}>
        Start
        <input
          type="date"
          value={startDate}
          onChange={(e) => onStartChange(e.target.value)}
          className="rounded border px-2 py-1 text-sm"
          style={{ borderColor: 'var(--border)', color: 'var(--text-main)' }}
          data-testid="shopping-range-start"
        />
      </label>
      <label className="flex flex-col text-xs" style={{ color: 'var(--text-muted)' }}>
        End
        <input
          type="date"
          value={endDate}
          onChange={(e) => onEndChange(e.target.value)}
          className="rounded border px-2 py-1 text-sm"
          style={{ borderColor: 'var(--border)', color: 'var(--text-main)' }}
          data-testid="shopping-range-end"
        />
      </label>
      <button
        type="button"
        onClick={onGenerate}
        disabled={generating}
        className="ml-auto flex min-h-[40px] items-center rounded-md px-3 text-sm font-medium"
        style={{
          background: 'var(--accent)',
          color: 'var(--accent-on)',
          opacity: generating ? 0.6 : 1,
        }}
        data-testid="shopping-generate"
      >
        {generating ? 'Generating…' : 'Generate list'}
      </button>
    </div>
  );
}
